import React from 'react';

function CustomButton({ onClick, children, disabled, className, btnColor, style }) {
  return (
    <button
      type='button'
      className={`btn active pointer_class ${className || ''} ${
        btnColor ? `btn-${btnColor}` : 'btn-primary'
      }`}
      disabled={disabled}
      onClick={onClick}
      style={style}
    >
      {children}
    </button>
  );
}

export default CustomButton;



// WEBPACK FOOTER //
// ./src/common/CustomButton.jsx